import axios from '../api';
import { getQueryData, getUrl } from '../utils';

const endPoint = getUrl('api') + '/api/v2/ScannedDocuments';

export const getValidatedSD = async ({ page, size, filters }) => {
  return axios
    .get(endPoint.concat('/validated', getQueryData(page, size, filters)), {})
    .then((response) => response)
    .catch((error) => error.response);
};

export const deleteValidatedSD = async ({ id }) => {
  return axios
    .delete(endPoint.concat(`/${id}`))
    .then((response) => response)
    .catch((error) => error.response);
};
